import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom'
import { getMealCategories, updateCustomerPrices, getCustomerPrices } from '../../services'

const CustomerPrices = (props) => {

  const [categoryPriceList, setCategoryPriceList] = useState()
  const [loaded, setLoaded] = useState(false)
  const [redirect, setRedirect] = useState(false)

  useEffect(() => {
    getMealCategories().then(res => {
      const list = []
      res.meal_categories.map((cat, i) => {
        list.push({id: cat.id, price: cat.price.toFixed(2).replace(".", ","), name: cat.name});
      })
      setCategoryPriceList(list)
    })
  }, [])

  useEffect(() => {
    if(categoryPriceList && loaded == false) {
      if (props.edit == "true") {
        getCustomerPrices(props.customerId).then(list => {
          list.pricelist.map((pricemap, i) => {
            updatePriceList(pricemap.id, pricemap.price.toFixed(2).replace(".", ","))
          })
        })
        setLoaded(true)
      }
    }
  },[categoryPriceList])

  const updatePriceList = (categoryId, price) => {
    const list = []
    categoryPriceList.map((cat, i) => {
      if(cat.id === categoryId) cat.price = price
      list.push(cat)
    })
    setCategoryPriceList(list)
  }

  const savePriceList = () => {
    updateCustomerPrices(props.customerId, categoryPriceList)
    setRedirect(true)
  }

  return (
    <div className="form__container__content">
      <div className="form__container__content__category">
        <span>Maaltijdprijzen</span>
      </div>
      <b style={{marginLeft: 40}}>Let op: Als de maaltijdprijzen voor de klant niet wordt ingevuld worden de standaardprijzen gebruikt</b>
      <div className="form__fields">
        {categoryPriceList && categoryPriceList.map((cat, i) => {
          return (
            <div key={i} className="form__fields__field">
              <span className="form__fields__field__label">{cat.name.charAt(0).toUpperCase() + cat.name.slice(1)}</span>
              <input
                value={cat.price}
                onChange={(e) => updatePriceList(cat.id, e.target.value)}
                type="text"
                className="form__fields__field__input"
              />
            </div>
          )
        })}
        <button
          className="form__container__content__button"
          onClick={() => savePriceList()}
        >
          OPSLAAN <i className="fas fa-arrow-right"></i>
        </button>
      </div>
      {redirect && <Redirect to="/customers" />}
    </div>
  );
}

export default CustomerPrices